import { render } from "./authApply.vue?vue&type=template&id=1b6bf1b4&scoped=true"
import script from "./authApply.vue?vue&type=script&lang=js"
export * from "./authApply.vue?vue&type=script&lang=js"

import "./authApply.vue?vue&type=style&index=0&id=1b6bf1b4&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6bf1b4"]])

export default __exports__